import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './app/App'

// Auto reload page on chunk/preload load errors (due to new build deployment)
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

window.addEventListener('error', (e) => {
  if (
    e.message &&
    (e.message.includes('Failed to fetch dynamically imported module') ||
      e.message.includes('chunk'))
  ) {
    window.location.reload()
  }
}, true)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
